import { asColorLabel } from '@app-types/color'
import type { AuthorProps } from '@components/article-byline'
import { Quote } from '@components/quote'
import type { QuoteFragment } from '@graphql/fragments/QuoteFragment.graphql'
import type { FunctionComponent } from 'react'

/**
 * Renders a quote, styled for articles.
 */
export const ArticleQuote: FunctionComponent<QuoteFragment> = ({
    color,
    text = '',
    author,
    alignment,
}) => (
    <Quote
        color={asColorLabel(color)}
        text={text}
        author={author as AuthorProps}
        alignment={alignment === 'left' ? 'left' : 'right'}
    />
)
